import React from 'react'
import { Stack, ButtonGroup } from '@mui/material'

interface GroupProps {
  withBorder?: boolean
  children: React.ReactNode
}

const Group: React.FC<GroupProps> = ({ withBorder = false, children }) => {
  if (withBorder) {
    return (
      <ButtonGroup orientation="vertical" aria-label="vertical outlined button group">
        {children}
      </ButtonGroup>
    )
  }
  return (
    <Stack>
      {children}
    </Stack>
  )
}

export default Group
